import { createContext } from 'react';

const messageContext = createContext();

export default messageContext;
